module.exports = __webpack_public_path__ + "img/P150T_weapon_60.e48ea762.png";